import {useContext} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import Context from '@s-ui/react-context'

const HelpText = ({userData}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const imageUrl = `${URL_STATICS_IMAGES}pictograms/Shield.svg`

  return (
    <div className="mt-TransactionSellerId-helpText">
      <img src={imageUrl} height={48} width={58} alt={i18n.t('VEHICLE_TRANSACTION.SELLER_ID.HELP_TEXT')} />
      <div className="mt-TransactionSellerId-helpTextInfo">{i18n.t('VEHICLE_TRANSACTION.SELLER_ID.HELP_TEXT')}</div>
    </div>
  )
}

HelpText.displayName = 'HelpText'
HelpText.propTypes = {
  userData: PropTypes.object
}

export default HelpText
